var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loading-container vld-parent', { hidden: !_vm.loading }]},[_c('loading',{attrs:{"active":_vm.loading,"is-full-page":false,"color":"#FC3F00","width":48,"height":48},on:{"update:active":function($event){_vm.loading=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae0342c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLoading.vue
// module id = null
// module chunks = 